module.exports = __webpack_public_path__ + "media/public/images/icon-filter-triangle-hover-da9af99d1afb80c48889e0e8c50d52c6.svg";